
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5 4.75a1.25 1.25 0 100 2.5h14a1.25 1.25 0 100-2.5H5zM2.25 6c0 1.259.846 2.32 2 2.646V18A2.75 2.75 0 007 20.75h10A2.75 2.75 0 0019.75 18V8.646A2.751 2.751 0 0019 3.25H5A2.75 2.75 0 002.25 6zm16 12V8.75H5.75V18A1.25 1.25 0 007 19.25h10A1.25 1.25 0 0018.25 18zM10 11.25a.75.75 0 000 1.5h4a.75.75 0 000-1.5h-4z"}})])
          )
        }
      }
    